import { useInfiniteQuery } from "@tanstack/react-query";
import { MessageInfo } from "@42maru/webchat";
import { emptyPage, MessageChannel, MessageFeedback, MessageHistorySearchType, Page } from "@/model";
import messageRepository from "@/repository/messageRepository";


interface UsePaginatedMessagesProps {
    scenarioId: string;
    size: number;
    sort: "asc" | "desc";
    start_date: string;
    end_date: string;
    searchType: MessageHistorySearchType;
    condition?: string;
    channel?: MessageChannel;
    feedback?: MessageFeedback;
}

interface PageParam {
    page: number;
    size: number;
}

const getData = async (
    scenarioId: string, 
    { page, size }: PageParam, 
    sort: "asc" | "desc",
    start_date: string, 
    end_date: string, 
    searchType: MessageHistorySearchType, 
    condition?: string,
    channel?: MessageChannel,
    feedback?: MessageFeedback
) => {
    const res = await messageRepository.find(scenarioId, page, size, sort, start_date, end_date, searchType, condition, channel, feedback);
    return res.data as Page<MessageInfo> || emptyPage<MessageInfo>();
};

export const usePaginatedMessages = (props: UsePaginatedMessagesProps) => {
    const { scenarioId, size, sort, start_date, end_date, searchType, condition, channel, feedback } = props;

    const initialParam = {
        page: 0,
        size: size
    };

    return useInfiniteQuery({
        queryKey: ['messages', 'paginated', scenarioId, initialParam.page, initialParam.size, sort, start_date, end_date, searchType, condition, channel, feedback],
        queryFn: ({ pageParam = initialParam }) => 
            getData(scenarioId, pageParam, sort, start_date, end_date, searchType, condition, channel, feedback),
        initialPageParam: initialParam,
        getNextPageParam: (lastPage) => {
            if (!lastPage?.has_next) 
                return undefined;

            return {
                page: lastPage.page + 1,
                size: lastPage.size
            };
        }
    });
};
